module.exports = __webpack_public_path__ + "media/bootstrap-icons/telegram-f274afe0.svg";